const hasGtag = () => {
  return (
    typeof window !== 'undefined' && typeof (window as any).gtag === 'function'
  );
};

export const setUserId = (userId: string) => {
  if (!hasGtag()) return;
  (window as any).gtag('set', { user_id: userId });
};

export const clearUserId = () => {
  if (!hasGtag()) return;
  (window as any).gtag('set', { user_id: null });
};

export const trackEvent = (name: string, params?: Record<string, any>) => {
  if (!hasGtag()) return;
  (window as any).gtag('event', name, params || {});
};

/* Query parameters that are one-time secrets: the 2FA-reset cancel token and the
 * set-password code. They must never reach analytics, where anyone with access to
 * the property could read and spend them. The rest of the query (UTM tags) stays. */
const SECRET_PARAMS = ['token', 'code'];
export const analyticsLocation = (href: string = window.location.href): string => {
  try {
    const url = new URL(href, window.location.origin);
    let changed = false;
    for (const p of SECRET_PARAMS) {
      if (url.searchParams.has(p)) {
        url.searchParams.set(p, 'redacted');
        changed = true;
      }
    }
    return changed ? url.toString() : href;
  } catch {
    return href;
  }
};

export const trackPageView = (path: string, title?: string) => {
  if (!hasGtag()) return;
  (window as any).gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: analyticsLocation()
  });
};
